var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var primary = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #7F39FA;\n  border-radius: 16px;\n  padding: 2px 6px;\n  display: grid;\n  height: fit-content;\n"], ["\n  background-color: #7F39FA;\n  border-radius: 16px;\n  padding: 2px 6px;\n  display: grid;\n  height: fit-content;\n"])));
var templateObject_1;
